import { IAP } from '@/utils/iap/iap';
import { IAPgetOfferings, IAPupdateOfferings } from '@/utils/iap/offerings';
import { IAPMockedProducts } from '@/utils/iap/mocked-products';
import { IAPproductConfig } from '@/utils/iap/product-config';

if (!window.hasOwnProperty('IAP')) window.IAP = IAP;

export {
    IAP,
    IAPMockedProducts,
    IAPgetOfferings,
    IAPupdateOfferings,
    IAPproductConfig,
};
